import { ApiClient } from './ApiClient';
import { ApiConnector } from '_helpers';
import apiConfig from '../config/apiConfig.default';

export default new ApiConnector(ApiClient, apiConfig);
